const SKIP_URL_PARTS = [
    '/o/token/',
    '/ingest/',
    '/checar-alerta/',
]

const SHOW_DELAY = 120
const MAX_VISIBLE = 30000

let pending = 0
let status = 'hidden'
const listeners = new Set()
let hideTimer = null
let completeTimer = null
let showTimer = null
let watchdogTimer = null

const emit = (next) => {
    status = next
    listeners.forEach((listener) => listener(status))
}

const clearHideTimers = () => {
    if (hideTimer) {
        clearTimeout(hideTimer)
        hideTimer = null
    }
    if (completeTimer) {
        clearTimeout(completeTimer)
        completeTimer = null
    }
}

const clearWatchdog = () => {
    if (watchdogTimer) {
        clearTimeout(watchdogTimer)
        watchdogTimer = null
    }
}

const show = () => {
    emit('loading')
    clearWatchdog()
    watchdogTimer = setTimeout(() => {
        pending = 0
        finish()
    }, MAX_VISIBLE)
}

const finish = () => {
    clearHideTimers()
    clearWatchdog()
    hideTimer = setTimeout(() => {
        emit('completing')
        completeTimer = setTimeout(() => emit('hidden'), 260)
    }, 160)
}

const shouldSkip = (config = {}) => {
    if (config.skipPageLoading) return true

    const url = String(config.url || '')
    return SKIP_URL_PARTS.some((part) => url.includes(part))
}

const start = () => {
    pending += 1
    clearHideTimers()

    if (status === 'loading' || showTimer) return

    if (status === 'completing') {
        show()
        return
    }

    showTimer = setTimeout(() => {
        showTimer = null
        if (pending > 0) show()
    }, SHOW_DELAY)
}

const done = () => {
    pending = Math.max(0, pending - 1)
    if (pending > 0) return

    if (showTimer) {
        clearTimeout(showTimer)
        showTimer = null
        return
    }

    if (status === 'hidden') return
    finish()
}

const subscribe = (listener) => {
    listeners.add(listener)
    listener(status)
    return () => listeners.delete(listener)
}

const pageLoading = {
    start,
    done,
    shouldSkip,
    subscribe,
}

export default pageLoading
